import TagManager from 'react-gtm-module';

import config from '../config';

const { UA_ID, OPT_ID, GTM_ID, GA4_ID } = config;
export class Gtm {
  static event(eventCategory, eventAction, eventLabel, value, otherVars = {}) {
    if (!!eventCategory && !!eventAction && !!eventLabel && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'UA_CREvent',
        customEvent: {
          eventCategory,
          eventAction,
          eventLabel,
          value,
          ...otherVars,
        },
      });
    }
  }

  static searchOffer(searchTerm, searchCategory) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'UA_CRData',
        customPage: [
          `/offers-result/?`,
          searchTerm ? `s=${searchTerm}` : undefined,
          !!searchCategory && searchCategory.length > 0 ? `&c=${searchCategory.join(' | ')}` : undefined,
        ].join(''),
      });
    }
  }

  static loadGTMScript() {
    if (window.performance) {
      window.dataLayer = window.dataLayer || [];
      const tagManagerArgs = {
        gtmId: GTM_ID,
      };
      TagManager.initialize(tagManagerArgs);
      window.dataLayer.push({
        event: 'UA_CRData',
        GA4_ID: GA4_ID,
        UA_ID: UA_ID,
        optimizeContainerId: OPT_ID,
      });
    }
  }

  // peut-être en avoir de besoin dans le futur, le laisser là pour l'instant
  // loadDataLayer(profile) {
  //     const {
  //         affInfos: { company, country, id, website },
  //         affUserInfos: { cell_phone, email, first_name, last_name },
  //     } = profile
  // }
}

const gtm = new Gtm();
export default gtm;
